import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { EditExclusionDialogWrapper } from '../../../components/application-exclusions/edit-exclusion-dialog'

export interface BridgeProps {
  organizationUuid: string
  applicationId: string
  exclusionId: string
  isOpen: boolean
  isRASPEnabled: boolean
  onClose: () => void
  onExclusionEdited: () => void
}

export function Bridge({
  organizationUuid,
  applicationId,
  exclusionId,
  isOpen,
  isRASPEnabled,
  onClose,
  onExclusionEdited
}: BridgeProps) {
  if (!exclusionId) {
    return <></>
  }

  return (
    <EditExclusionDialogWrapper
      organizationUuid={organizationUuid}
      applicationId={applicationId}
      exclusionId={exclusionId}
      isOpen={isOpen}
      isRASPEnabled={isRASPEnabled}
      closeDialog={onClose}
      successCallback={onExclusionEdited}
    />
  )
}

export const reactEditExclusionDialog = createNgReactBridgeDirective(
  'reactEditExclusionDialog',
  [],
  Bridge,
  [
    'organizationUuid',
    'applicationId',
    'exclusionId',
    'isOpen',
    'isRASPEnabled',
    'onClose',
    'onExclusionEdited'
  ]
)
